<template lang="pug">
  .curriculum-top-field.input-field
    label {{ label }}

    video-field(
      v-model="video"
      :selectedVideo="selectedVideo"
      @upload="$emit('upload', $event)"
      @playback="playbackVideo")

    multiline-text-field(
      v-model="description"
      placeholder="カリキュラムの説明を入力")
</template>

<style lang="scss" scoped>
.input-field {
  background-color: rgba(255, 255, 255, 0.06);
  box-sizing: border-box;
  padding-top: 18px;
  padding-bottom: 20px;
}

label {
  @extend %label-text;
  margin-left: 16px;
  white-space: nowrap;
}

.video-field {
  margin-top: 12px;
}

.multiline-text-field {
  margin: 24px 16px 0 16px;
  height: 150px;
}
</style>

<script>
import VideoPlayable from '@/components/mixins/VideoPlayable'
import VideoField from '@/components/molecules/VideoField'
import MultilineTextField from '@/components/molecules/MultilineTextField'

export default {
  props: {
    label: { type: String },
    value: { type: Object },
    curriculum: { type: Object },
  },
  mixins: [VideoPlayable],
  components: {
    VideoField,
    MultilineTextField,
  },
  computed: {
    selectedVideo() {
      return this.curriculum && this.curriculum.video
    },
    description: {
      get() {
        return this.value.description
      },
      set(description) {
        this.updateValue({ description })
      },
    },
    video: {
      get() {
        return {
          videoKey: this.value.videoKey,
          thumbnailKey: this.value.thumbnailKey,
        }
      },
      set({ videoKey, thumbnailKey }) {
        this.updateValue({ videoKey, thumbnailKey })
      },
    },
  },
  methods: {
    updateValue(diff) {
      this.$emit('input', { ...this.value, ...diff })
    },
  },
}
</script>
